/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleCircleIcon16Regular = forwardRef('MoneyCurrencyRubleCircleIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.2 9h1.775a2.5 2.5 0 0 0 0-5H6.804A.804.804 0 0 0 6 4.804V7.8h-.4a.6.6 0 1 0 0 1.2H6v.8h-.4a.6.6 0 1 0 0 1.2H6v.75a.6.6 0 1 0 1.2 0V11h2.2a.6.6 0 1 0 0-1.2H7.2V9Zm0-3.8v2.6h1.775a1.3 1.3 0 0 0 0-2.6H7.2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm7-5.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z" })));
});
